import { clientRect } from "../../utils/client-rect";
import { clamp, map } from "../../utils/math";
import { Observe } from "./observe";
import { Scroll } from "../../scroll";
import { Resize } from "../../utils/subscribable";

const DEFAULT_CONFIG = {
  bounds: [0, 1],
  top: "bottom",
  bottom: "top",
  callback: undefined,
};

export class Track extends Observe {
  value = 0;
  #init = false;

  bounds;
  config;

  #scrollSub;
  #resizeSub;

  constructor(element, config = {}) {
    super(element, {
      autoStart: false,
      once: false,
      threshold: 0,
    });

    this.element = element;
    this.config = {
      ...DEFAULT_CONFIG,
      ...config,
    };

    this.#resize();
    this.#scrollSub = Scroll.subscribe(this.#handleScroll);
    this.#resizeSub = Resize.subscribe(this.#resize);
    this.#handleScroll();
    this.#init = true;

    setTimeout(() => queueMicrotask(() => this.triggerResize()), 1000);
  }

  triggerResize() {
    this.#resize();
  }

  #resize = () => {
    this.bounds = computeBounds(this.element, this.config);
    this.resize?.(this.bounds);
    this.#handleScroll();
  };

  #handleScroll = () => {
    if (!this.inView || !this.#init) return;
    this.value = clamp(
      this.config.bounds[0],
      this.config.bounds[1],
      map(
        Scroll.y,
        this.bounds.top,
        this.bounds.bottom,
        this.config.bounds[0],
        this.config.bounds[1]
      )
    );

    this.handleScroll?.(this.value);
    this.config.callback?.(this.value);
  };

  destroy() {
    this.config.callback = undefined;
    this.#scrollSub();
    this.#resizeSub();
    super.destroy();
  }
}

function computeBounds(el, config) {
  const bounds = clientRect(el);
  const { top: topPos, bottom: bottomPos, wh } = bounds;

  const centerOffset = wh / 2;

  bounds.top =
    topPos -
    (config.top === "center" ? centerOffset : config.top === "bottom" ? wh : 0);

  bounds.bottom =
    bottomPos -
    (config.bottom === "center"
      ? centerOffset
      : config.bottom === "bottom"
        ? wh
        : 0);

  return bounds;
}

